import { apiFetch } from "../../utils/apiFetch";
export async function feedRequest(path, options = {}) {
  const response = await apiFetch(`${process.env.API_URL}/api${path}`, {
    ...options,
    headers: { "Content-Type": "application/json",  ...options.headers },
  });
  if (response.status === 204) return null;
  const data = await response.json();
  if (!response.ok) throw Object.assign(new Error(data.message || "Unable to update feed"), { status: response.status });
  return data;
}
